// extracted by mini-css-extract-plugin
export default {"root":"-C0vn","requirement":"iDl+f","description":"ah8AJ","fulfilled":"_2FvQy","notFulfilled":"_0SRy-"};